import BBCodeTag from './BBCodeTag';

import FormattingTags from './formatting';
import LayoutTags from './layout';

export const BBCodeTags: BBCodeTag[] = [...LayoutTags, ...FormattingTags];
